module.exports = __webpack_public_path__ + "img/Flag_of_Canada.a39c5875.svg";